import moment from 'moment-timezone';

export const formatDate = (date: string) => {
    const language = localStorage.getItem('entityLanguage');
    return {
        day: moment(new Date(date)).format('DD'),
        month: new Intl.DateTimeFormat(language?.toLowerCase().substring(0, 2), { month: 'long' })
            .format(new Date(date))
            .substring(0, 3),
        weekday: language === 'English'
            ? moment(new Date(date)).format('ddd')
            : new Intl.DateTimeFormat(localStorage.getItem('entityLanguage')?.toLowerCase().substring(0, 2), { weekday: 'short' })
                .format(new Date(date))
                .replace('יום ', ''),
    };
};


export const isSelectedDay = (day: string, selectedDay: string) => {
    const dayFormatted = moment(new Date(day)).format('DD MM YYYY');
    const selectedFormatted = moment(new Date(selectedDay)).format('DD MM YYYY');
    return dayFormatted === selectedFormatted;
};